const HTTPS = 'https:';

export const domainFolder = (): string => {
  return '/' + window.location.pathname.replace(/^\/|\/$/g, '');
};

export const isSecure = (): boolean => {
  return window.location.protocol.toLowerCase() === HTTPS;
};

